import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IRegistrationSubmission } from '../../models/account/registration-submission';
import { ILabSubmission } from '../../models/account/lab-submission';
import { IRegistrationResult } from '../../models/account/registrationResult';
import { ILabUser } from '../../models/lab-user-menu/lab-user';
import { IUserUpdate } from '../../models/account/user-update';
import { IUpdateUserResult } from '../../models/account/user-update-result';
import { DNTCaptchaApiResponse } from '../../models/dnt-captcha/dnt-captcha-api-response';
import { environment } from '@env/environment';
import { ILogin } from 'app/models/account/login';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

const dntOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded'
  })
};

@Injectable({
  providedIn: 'root',
})

export class AccountService {
  private api: string = environment.publicApi + 'Account/';
  loginName: string = null;

  states: string[] = [
    "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA", "HI", "ID", "IL",
    "IN", "IA", "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT",
    "NE", "NV", "NH", "NJ", "NM", "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI",
    "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", "WV", "WI", "WY"
  ];

  constructor(private http: HttpClient) {}

  getRegistrationLabs(): Observable<ILabSubmission[]> {
    return this.http.get<ILabSubmission[]>(this.api + 'getRegistrationLabs', httpOptions);
  }

  registerLabs(labRegistration: IRegistrationSubmission): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'registerLabs', labRegistration, httpOptions);
  }

}
